import React, { useState } from "react";
// import axios from "axios";
import MessageBox from "./MessageBox";
import { useAuth } from "../../../Context/UnifiedAuthContext";

const InputField = ({ 
  type, 
  placeholder, 
  value, 
  onChange, 
  icon, 
  focused, 
  onFocus, 
  onBlur,
  showToggle = false,
  onToggle = null 
}) => (
  <div className="relative group">
    <div className={`absolute left-3 top-1/2 transform -translate-y-1/2 transition-all duration-200 ${
      focused || value ? 'text-[#10c9c0]' : 'text-gray-400 group-hover:text-gray-600'
    }`}>
      {icon}
    </div>
    
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      onFocus={onFocus}
      onBlur={onBlur}
      className={`w-full pl-10 pr-${showToggle ? '10' : '4'} py-3 border-2 rounded-xl bg-gray-50/50 transition-all duration-200 placeholder-gray-400 focus:placeholder-gray-300 ${
        focused || value
          ? 'border-[#10c9c0] bg-white shadow-lg shadow-[#10c9c0]/10 focus:outline-none'
          : 'border-gray-200 hover:border-gray-300 focus:border-[#10c9c0] focus:bg-white focus:outline-none focus:shadow-lg focus:shadow-[#10c9c0]/10'
      }`}
      required
    />
    
    {showToggle && (
      <button
        type="button"
        onClick={onToggle}
        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors duration-200"
      >
        {type === 'password' ? (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
        ) : (
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
          </svg>
        )}
      </button>
    )}
  </div>
);

const LoginForm = ({ onToggle, onForgetPassword }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [emailFocused, setEmailFocused] = useState(false);
  const [passwordFocused, setPasswordFocused] = useState(false);
  const { login, setShowModal } = useAuth();

  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const user = await login(email, password);
      console.log("user")
      console.log(user)

      console.log("user")
      setMessage("Login successful!");
      setMessageType("success");
      setShowModal(false);
    } catch (error) {
      setMessage(error.response?.data?.detail || "Login failed");
      setMessageType("error");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="text-center space-y-2">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-[#10c9c0] to-[#0eb1a9] rounded-2xl mb-4">
          <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900">Welcome back</h2>
        <p className="text-gray-600">Sign in to your account to continue</p>
      </div>

      {/* Message Box */}
      {message && (
        <div className="animate-in fade-in slide-in-from-top-2 duration-300">
          <MessageBox message={message} type={messageType} />
        </div>
      )}

      {/* Login Form */}
      <form onSubmit={handleLogin} className="space-y-4">
        <InputField
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          focused={emailFocused}
          onFocus={() => setEmailFocused(true)}
          onBlur={() => setEmailFocused(false)}
          icon={
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
            </svg>
          }
        />

        <InputField
          type={showPassword ? "text" : "password"}
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          focused={passwordFocused}
          onFocus={() => setPasswordFocused(true)}
          onBlur={() => setPasswordFocused(false)}
          showToggle={true}
          onToggle={() => setShowPassword(!showPassword)}
          icon={
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
            </svg>
          }
        />

        {/* Login Button */}
        <button
          type="submit"
          className="w-full py-3 px-4 rounded-xl font-medium text-white transition-all duration-200 bg-gradient-to-r from-[#10c9c0] to-[#0eb1a9] hover:from-[#0eb1a9] hover:to-[#10c9c0] hover:scale-[1.02] hover:shadow-lg hover:shadow-[#10c9c0]/25 active:scale-[0.98]"
        >
          <div className="flex items-center justify-center space-x-2">
            <span>Sign In</span>
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </button>
      </form>

      {/* Footer Links */}
      <div className="space-y-4">
        {/* Forgot Password */}
        <div className="text-center">
          <button 
            onClick={onForgetPassword} 
            className="text-[#10c9c0] hover:text-[#0eb1a9] font-medium transition-colors duration-200 relative group"
          >
            Forgot your password?
            <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-[#10c9c0] transition-all duration-200 group-hover:w-full"></span>
          </button>
        </div>

        {/* Divider */}
        <div className="relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-200"></div>
          </div>
          <div className="relative flex justify-center text-sm">
            <span className="px-4 bg-white text-gray-500">Don't have an account?</span>
          </div>
        </div>

        {/* Sign Up Link */}
        <div className="text-center">
          <button 
            onClick={onToggle} 
            className="inline-flex items-center px-6 py-2 border-2 border-[#10c9c0] text-[#10c9c0] rounded-xl font-medium hover:bg-[#10c9c0] hover:text-white transition-all duration-200 hover:scale-105 active:scale-95"
          >
            Create Account
            <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;